var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vtextbox cursor-help",style:([_vm.sizeStyle, _vm.clampStyle]),attrs:{"title":_vm.text}},[(_vm.maxChars && _vm.text && _vm.text.length >= _vm.maxChars)?[_vm._v(_vm._s(_vm.truncateText(_vm.text)))]:[_vm._v(_vm._s(_vm.text === null || _vm.text.length === 0 ? _vm.defaultEmptyText : _vm.text))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }